import ReactConfetti from "react-confetti";
import styles from '../style/verification_successful_style.module.css';
import { LoginRoute } from "../../../../../core/routes/route_constants";
import { useNavigate } from "react-router-dom";
const VerificationSuccessfulComp = () => {
    const Wave_1_2000 = "/images/wave_1_2000.png";
    const navigate = useNavigate();
    const goToLogin = () => {
        navigate(LoginRoute);
    }
    return (
        <div className={`${styles.container} bg-gradient-signup`}>
            <ReactConfetti 
                width={window.innerWidth} 
                height={window.innerHeight} 
                colors={['#B7A0FC', '#1E2259', '#383775']} 
                recycle={false}
                numberOfPieces={2000}
            />
            <div className="register-wave-container">
                <img src={Wave_1_2000} alt="Wave Background" />
            </div>
            {/* Wave Image */}
            <div className={styles.content}>
                <h3 className={styles.header_title}>Eve Awaits You</h3>
                <p>
                    Step closer and let your desires be unveiled in ways you never imagined.
                </p>
                <button className={`btn-horizontal-gradient border-none py-2 px-3 border-round-2xl text-base border-1 p-button ${styles.button}`} onClick={goToLogin}>Login</button>
            </div>
        </div>
    )
}

export default VerificationSuccessfulComp;